// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__fs_eP","info":"Note_info__32poa","note":"Note_note__1Rxox","actions":"Note_actions__1HWYE"};